import React, { FC } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TLatestNewsCardItemProps, TLatestNewsProps } from './types/latestNews.types';
import { LatestNewsModel } from './models/latestNews.model';
import NewsCard from './components/newsCard/index';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import RoutableSitecoreLink from '../@shared/routableSitecoreLink';
import DictionaryTerm from '../@shared/dictionaryTerm';
import Icon from '../@shared/icon';
import { iconSize } from '../../constants/icon.constants';
import './styles.scss';

const LatestNews: FC<TLatestNewsProps> = (props) => {
  const model = new LatestNewsModel(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <div className="latest-news">
      <div className="latest-news__heading-wrapper">
        <div className="latest-news__heading-eyebrow">
          <DictionaryTerm keyword="cnhi-news-latest-eyebrow" />
        </div>

        <div className="latest-news__heading-text">
          <div className="latest-news__heading-title">
            <DictionaryTerm keyword="cnhi-news-latest-title" />
          </div>

          <RoutableSitecoreLink field={model?.link} className="latest-news__heading-link">
            <DictionaryTerm keyword="cnhi-showAll" />
            <Icon iconName="arrow-chevron-right" size={iconSize.dsk} color={'primary'} extraClassName="cta-with-arrow__icon" />
          </RoutableSitecoreLink>
        </div>
      </div>

      <div className="latest-news__cards-wrapper">
        {model?.items?.map((item: TLatestNewsCardItemProps, index) => (
          <NewsCard
            item={item}
            key={model?.items?.length + index}
            cardHeadingTitleTag={model?.headingTag}
            sitecoreContext={props?.sitecoreContext}
            defaultCardImage={model?.defaultCardImage}
          />
        ))}
      </div>
    </div>
  );
};

export default withSitecoreContext()(LatestNews);
